<template>
	<div class="w-full">
		<vs-row v-if="condition">
			<vs-col class="mb-6 md:mb-0" vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-lg="6">
			   <Number v-model="questionsByPage[index].properties.minValue" :label="$t('MODULE.getDateYear')" :min="1970" @blur="resetMin($event, 'minValue')" :max="maxi"/>
			</vs-col>
			<vs-col vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-lg="6">
			   <Number v-model="questionsByPage[index].properties.maxValue" :label="$t('MODULE.toYear')" :min="mini" @blur="resetMin($event, 'maxValue')"/>
			</vs-col>
		</vs-row>

		<vs-row v-else-if="!condition" vs-justify="center">
			<vs-col class="mb-6 md:mb-0" vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-lg="6">
			   <Default :index="index" :label="$t('MODULE.selectFormatDate')"></Default>
			</vs-col>
		</vs-row>
	</div>

</template>

<script type="text/javascript">
	import  Number  from '../../components/Number.vue';
	import Default from '../../componentsToQuestions/DefaultSelect.vue';
	import { mapState } from 'vuex';

	export default {
		components: { Number, Default },
		props: ['index'],
		methods: {
			resetMin(value, property) {
				if(value < 1970) this.questionsByPage[this.index].properties[property] = 1970;
				if(this.mini > this.maxi) this.questionsByPage[this.index].properties.minValue = this.maxi;
			},
		},
		computed: {
			...mapState('resource',['questionsByPage']),
            /**
             * Verifica el subtipo de componente ó pregunta
             */
			condition() {
				const condition = (this.inputType === 'datetime' || this.inputType === 'calendar');
				return condition;
			},
            /**
             * Obtiene el valor máximo
             */
			maxi() {
				return this.questionsByPage[this.index].properties.maxValue;
			},
            /**
             * Obtiene el valor mínimo
             */
			mini() {
				return this.questionsByPage[this.index].properties.minValue;
			},
            /**
             * Obtiene el subtipo de componente ó pegunta
             */
			inputType() {
				return this.questionsByPage[this.index].inputType;
			}
		}
	}
</script>
